export default formOptionsToggle => {
    if ($('.options').length < 1) {
        return false;
    }

    let $options = $('.options');
    let $optionsToggle = $('.options-toggle');

    $('.options-toggle').on('click', e => {
        e.preventDefault();

        if ($options.is(':visible')) {
            $optionsToggle.removeClass("is-active");

            return $options.slideUp(600);
        }

        $optionsToggle.addClass("is-active");

        return $options.slideDown(600);
    });
};
